import React, { useState } from 'react'
import styled from 'styled-components'

import { DropdownList } from 'Components/Shared/Form'
import InputText from 'Components/Shared/Input/InputText'
import {
  QCType,
  JobType,
  CheckListDetail,
  SubJobType,
} from 'features/checklist/unit/types'
import { SelectType } from '..'
import { BottomButton } from 'Components/Shared/Button'

interface Props {
  selected: SelectType
  checkListDetail: CheckListDetail
  editingObj?: SubJobType
  onSave: (subjob: SubJobType) => void
  closeModal: () => void
  disabled: boolean
}

const SubJobModal: React.FC<Props> = ({
  checkListDetail,
  selected,
  editingObj,
  onSave: onSaveProp,
  closeModal,
  disabled,
}) => {
  const [error, seterror] = useState('')
  const [name, setname] = useState(editingObj ? editingObj.SubJobTypeName : '')
  const [qcType, setqcType] = useState<QCType>(
    checkListDetail.QCTypeList[selected.qcType]
  )
  const [jobList, setjobList] = useState<JobType[]>(
    qcType.JobTypeList ? qcType.JobTypeList : []
  )
  const [job, setjob] = useState<JobType | null>(
    jobList ? jobList[selected.job] : null
  )

  const onSave = () => {
    if (name && job) {
      const found = editingObj
        ? null
        : job.SubJobTypeList.find(v => v.SubJobTypeName === name)
      if (found == null) {
        onSaveProp({
          SubJobTypeName: name,
          DetailList: editingObj ? editingObj.DetailList : [],
        })
      } else {
        seterror('ลักษณะงานรองนี้ ได้มีอยู่แล้ว')
      }
    } else {
      seterror('กรุณาใส่ข้อมูลทั้งหมด')
    }
  }

  const changeName = (val: string) => {
    setname(val)
  }

  const selectQcType = (item: QCType) => {
    setqcType(item)
    setjobList(item.JobTypeList)
    setjob(null)
  }

  const selectJob = (item: JobType) => {
    setjob(item)
  }

  const menuChoice = () => {
    const result = checkListDetail.QCTypeList.map((item: QCType) => (
      <DataItem key={item.QCTypeID} onClick={() => selectQcType(item)}>
        {item.QCTypeName}
      </DataItem>
    ))
    return result
  }

  const menuChoiceJob = () => {
    const result = jobList.map((item: JobType, index: number) => (
      <DataItem key={index} onClick={() => selectJob(item)}>
        {item.JobTypeName}
      </DataItem>
    ))
    return result
  }

  return (
    <MainView>
      <DropdownBox>
        <InputText
          prefix="ชื่อ"
          value={name}
          placeholder="กรอกชื่อ"
          onChange={changeName}
          openWithFocus
          disabled={disabled}
        />
      </DropdownBox>

      <DropdownBox>
        <div className="dropdown-item">
          <DropdownList
            label="หมวดงาน"
            value=""
            placeholder={qcType ? qcType.QCTypeName : 'กรุณาเลือก'}
            menuChoice={menuChoice()}
            disabled={!!editingObj}
          />
        </div>
      </DropdownBox>

      <DropdownBox>
        <div className="dropdown-item">
          <DropdownList
            label="ลักษณะงานหลัก"
            value=""
            placeholder={job ? job.JobTypeName : 'กรุณาเลือก'}
            menuChoice={menuChoiceJob()}
            disabled={!!editingObj}
          />
        </div>
      </DropdownBox>

      {!disabled && (
        <BottomButton closeModal={closeModal} onSave={onSave} error={error} />
      )}
    </MainView>
  )
}

const MainView = styled.div``

const DropdownBox = styled.div`
  padding-top: 12px;
`

const DataItem = styled.div`
  padding: 5px 10px;

  &:hover {
    cursor: pointer;
    color: white;
    background-color: #003168;
  }
`

export default SubJobModal
